import { render, staticRenderFns } from "./Informs.vue?vue&type=template&id=147b8eba&scoped=true&"
import script from "./Informs.vue?vue&type=script&lang=js&"
export * from "./Informs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147b8eba",
  null
  
)

export default component.exports